import { initStore } from "./store";

const configureStore = () => {
  const actions = {
    SET_GLOADING: (state, payload) => {
      return { 
        // ...state,
        uiStore : {
          ...state.uiStore,
          gLoading: payload, 
        }
      };
    },
    SET_SRVLOADING: (state, payload) => {
      return { 
        // ...state,
        uiStore : {
          ...state.uiStore,
          srvLoading: payload, 
        }
      };
    },
    // SET_METALOADING: (state, payload) => {
    //   return { 
    //     // ...state,
    //     uiStore : {
    //       ...state.uiStore,
    //       metaLoading: payload, 
    //     }
    //   };
    // },
    
    // SET_WINDOW_VALUES: (state, payload) => {
    //   return {
    //     // ...state,
    //     uiStore : {
    //       ...state.uiStore,
    //       windowValues: payload,
    //     }
    //   }
    // },
    // SET_BOWSERDATA: (state, payload) => {
    //   return {
    //     // ...state,
    //     uiStore : {
    //       ...state.uiStore,
    //       bowserData: payload,
    //     }
    //   }
    // },
    // SET_SHOWTOGGLENAV: (state, payload) => {
    //   return {
    //     // ...state,
    //     uiStore : {
    //       ...state.uiStore,
    //       showToggleNav: payload,
    //     }
    //   }
    // },
    SET_ISAUTH: (state, payload) => {
      return {
        // ...state,
        uiStore : {
          ...state.uiStore,
          isAuth: payload,
        }
      }
    },
    // SET_ISADMIN: (state, payload) => {
    //   return {
    //     // ...state,
    //     uiStore : {
    //       ...state.uiStore,
    //       isAdmin: payload,
    //     }
    //   }
    // },

    SET_ISALLAPIS: (state, payload) => {
      return {
        // ...state,
        uiStore : {
          ...state.uiStore,
          isAllApis: payload,
        }
      }
    },
  };

  initStore(actions, {
    uiStore: {
      gLoading: false,
      srvLoading: false,
      // metaLoading: false,

      // windowValues: null,
      // bowserData: null,
      
      // showToggleNav: false,

      isAuth: false,
      // isAdmin: false,

      isAllApis: false,
    }
  });
};

export default configureStore;
